import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { payService } from "../services";

const MeterClassCodings = [
  { id: 2, name: "电表" },
  { id: 1, name: "水表" },
  { id: 3, name: "燃气表" },
  { id: 4, name: "热量表" }
];

const PayChannelCodings = [
  { id: 1, name: "微信支付" },
  { id: 2, name: "支付宝" },
  { id: 3, name: "微信支付HF" },
  { id: 4, name: "支付宝HF" },
  { id: 5, name: "企业网银" }
];

const initialState = {
  meterClass: MeterClassCodings,
  payChannels: PayChannelCodings,
  banksOfB2b: [],
  status: "idle",
  error: null
};

export const refreshBanksOfB2b = createAsyncThunk("coding/refreshBanksOfB2b", async () => {
  const res = await payService.getBanksOfB2BNSPOS();
  return res.data;
});

const codingSlice = createSlice({
  name: "coding",
  initialState,
  reducers: {
    clearBanksOfB2b: state => {
      state.banksOfB2b = [];
    }
  },
  extraReducers: {
    [refreshBanksOfB2b.pending]: (state, action) => {
      state.status = "loading";
    },
    [refreshBanksOfB2b.fulfilled]: (state, action) => {
      state.status = "succeeded";
      state.banksOfB2b = action.payload;
    },
    [refreshBanksOfB2b.rejected]: (state, action) => {
      state.status = "failed";
      state.error = action.error.message;
    }
  }
});

export const { clearBanksOfB2b } = codingSlice.actions;

export const selectMeterClassCodings = (state) => state.coding.meterClass;
export const selectPayChannels = (state) => state.coding.payChannels;
export const selectBanksOfB2b = (state) => state.coding.banksOfB2b;

export default codingSlice.reducer;
